export const NAMESPACE = "OrganizationImportEvents";

export const FORM_ID = "ImportEventsForm";

export const ERROR_MESSAGE = "Please fill out the required fields";

export const UNMAPPED_EVENT_ID = "unmapped";

export const SESSIONBOARD_LOGO_URL =
  "https://d2ams66j58uyd5.cloudfront.net/images/sessionboard-square-logo.png";

export const CHECKBOX_STYLES = {
  color: "#1E62D8",
  "&.Mui-checked": {
    color: "#1E62D8"
  },
  padding: 0,
  width: "20px",
  height: "20px"
};

export const STEPS = ["Select Source", "Connect", "Preview", "Import"];

export const STEP_IDS = {
  SELECT_SOURCE: "select-source",
  CONNECT: "connect",
  PREVIEW: "preview",
  IMPORT: "import"
};

export const SOURCE_IDS = {
  CVENT: "cvent-crm",
  SWOOGO: "swoogo-crm",
  ON24: "on24"
};

export const SOURCES = {
  [SOURCE_IDS.CVENT]: {
    id: SOURCE_IDS.CVENT,
    title: "Cvent",
    urlDoc: "https://learn.sessionboard.com/en/knowledge-base",
    logoUrl:
      "https://cdn.prod.website-files.com/627d5c68d5739680264cfd2c/653bd66da73b64de2231d9b6_download.png",
    description: "Import your events and speakers from Cvent",
    selectedBackgroundColor: "#dbeff7"
  },
  [SOURCE_IDS.SWOOGO]: {
    id: SOURCE_IDS.SWOOGO,
    title: "Swoogo",
    urlDoc: "https://learn.sessionboard.com/en/knowledge-base",
    logoUrl:
      "https://pbs.twimg.com/profile_images/1550517893854646274/k25W38lw_400x400.jpg",
    description: "Import your events and speakers from Swoogo",
    selectedBackgroundColor: "#ffeae2"
  },
  [SOURCE_IDS.ON24]: {
    id: SOURCE_IDS.ON24,
    title: "On24",
    urlDoc: "https://learn.sessionboard.com/en/knowledge-base",
    logoUrl:
      "https://images.seeklogo.com/logo-png/42/1/on24-logo-png_seeklogo-424758.png",
    description: "Import your webinars and speakers from On24",
    selectedBackgroundColor: "#e8e9f4"
  }
};

export const AUTH_FORM_SETUP = {
  [SOURCE_IDS.ON24]: {
    accessTokenKey: {
      type: "input",
      label: "Access Token Key",
      key: "accessTokenKey"
    },
    accessTokenSecret: {
      type: "password",
      label: "Access Token Secret",
      key: "accessTokenSecret"
    },
    clientId: {
      type: "input",
      label: "Client ID",
      key: "clientId"
    }
  },
  [SOURCE_IDS.CVENT]: {
    clientId: {
      type: "input",
      label: "Cvent Client ID",
      key: "clientId",
      mock: "jakzlHQLq78EnT1vJJ79LcVR1ywnlKRX"
    },
    clientSecret: {
      type: "password",
      label: "Cvent Client Secret",
      key: "clientSecret",
      mock: "a5nbXoSRCeZ74NyDY_CDeot0c4LCd7XtKMrjtcfN5xzfq6PrwlTERmfLLQdXMEeo"
    },
    endpoint: {
      type: "input",
      label: "Cvent Endpoint",
      key: "endpoint",
      placeholder: "Example: https://api-platform.cvent.com",
      mock: "https://api-platform.cvent.com"
    }
  },
  [SOURCE_IDS.SWOOGO]: {
    consumerKey: {
      type: "password",
      label: "Consumer Key",
      key: "consumerKey"
    },
    consumerSecret: {
      type: "password",
      label: "Consumer Secret",
      key: "consumerSecret"
    }
  }
};

export const getAuthenticationUrl = (integrationId, orgId) => {
  switch (integrationId) {
    case SOURCE_IDS.ON24:
      return `/integrations/on24/org/${orgId}/auth?multiple=true`;
    case SOURCE_IDS.CVENT:
      return `/integrations/cvent-crm/org/${orgId}/auth`;
    case SOURCE_IDS.SWOOGO:
      return `/integrations/swoogo-crm/org/${orgId}/auth`;
    default:
      return "";
  }
};

export const getEditAuthenticationUrl = (integrationId, orgId, configId) => {
  switch (integrationId) {
    case SOURCE_IDS.ON24:
      return `/integrations/on24/org/${orgId}/auth/${configId}`;
    case SOURCE_IDS.CVENT:
      return `/integrations/cvent-crm/org/${orgId}/auth/${configId}`;
    case SOURCE_IDS.SWOOGO:
      return `/integrations/swoogo-crm/org/${orgId}/auth/${configId}`;
    default:
      return "";
  }
};

export const getCampaignsUrl = (integrationId, orgId) => {
  switch (integrationId) {
    case SOURCE_IDS.ON24:
      return `/integrations/on24/org/${orgId}/events`;
    case SOURCE_IDS.CVENT:
      return `/integrations/cvent-crm/org/${orgId}/events`;
    case SOURCE_IDS.SWOOGO:
      return `/integrations/swoogo-crm/org/${orgId}/events`;
    default:
      return "";
  }
};

export const getEventsMappingUrl = (integrationId, orgId) => {
  switch (integrationId) {
    case SOURCE_IDS.ON24:
      return `/integrations/on24/org/${orgId}/event-mappings`;
    case SOURCE_IDS.CVENT:
      return `/integrations/cvent-crm/org/${orgId}/event-mappings`;
    case SOURCE_IDS.SWOOGO:
      return `/integrations/swoogo-crm/org/${orgId}/event-mappings`;
    default:
      return "";
  }
};

export const getConnectionEventMappingsUrl = (
  integrationId,
  orgId,
  connectionId
) => {
  switch (integrationId) {
    case SOURCE_IDS.ON24:
      return `/integrations/on24/org/${orgId}/config/${connectionId}/event-mappings`;
    case SOURCE_IDS.CVENT:
      return `/integrations/cvent-crm/org/${orgId}/config/${connectionId}/event-mappings`;
    case SOURCE_IDS.SWOOGO:
      return `/integrations/swoogo-crm/org/${orgId}/config/${connectionId}/event-mappings`;
    default:
      return "";
  }
};

export const getSyncEventsUrl = (integrationId, orgId, configId) => {
  switch (integrationId) {
    case SOURCE_IDS.CVENT:
      return `/integrations/cvent-crm/org/${orgId}/config/${configId}/sync`;
    case SOURCE_IDS.SWOOGO:
      return `/integrations/swoogo-crm/org/${orgId}/config/${configId}/sync`;
    case SOURCE_IDS.ON24:
      return `/integrations/on24/org/${orgId}/config/${configId}/sync`;
    default:
      return "";
  }
};

export const getConnectionDeleteEventMappingsUrl = (
  integrationId,
  orgId,
  connectionId,
  eventMappingId
) => {
  switch (integrationId) {
    case SOURCE_IDS.ON24:
      return `/integrations/on24/org/${orgId}/config/${connectionId}/event-mappings/${eventMappingId}`;
    case SOURCE_IDS.CVENT:
      return `/integrations/cvent-crm/org/${orgId}/config/${connectionId}/event-mappings/${eventMappingId}`;
    case SOURCE_IDS.SWOOGO:
      return `/integrations/swoogo-crm/org/${orgId}/config/${connectionId}/event-mappings/${eventMappingId}`;
    default:
      return "";
  }
};

export const getFieldMappingsUrl = ({
  integrationId,
  orgId,
  eventId,
  integrationEventId
}) => {
  switch (integrationId) {
    case SOURCE_IDS.ON24:
      return `/integrations/on24/org/${orgId}/event/${eventId}/integration-event/${integrationEventId}/field-mappings`;
    case SOURCE_IDS.CVENT:
      return `/integrations/cvent-crm/org/${orgId}/event/${eventId}/integration-event/${integrationEventId}/field-mappings`;
    case SOURCE_IDS.SWOOGO:
      return `/integrations/swoogo-crm/org/${orgId}/event/${eventId}/integration-event/${integrationEventId}/field-mappings`;
    default:
      return "";
  }
};
